import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Elements
import Panel from '../../../shared/elements/panel'
import Text from '../../../shared/elements/text'
import Col from '../../../shared/elements/col'
import Grid from '../../../shared/elements/grid'
import Row from '../../../shared/elements/row'

// Styles
import './view.scss'

// Utils
import { translation } from '../../../utils/helpers'
import { formatCurrency, reverseFormatCurrency, formatCurrency2 } from '../../../utils/currency'

// Actions
import { getCollaboratingPartnerInvoiceSetting, createSavePartnerInvoiceSetting } from '../../../actions/collaboratingPartners'

class View extends Component {
  constructor (props) {
    super(props)
    this.state = {
      PartnerInvoiceSetting: {
        PartnerInvoiceSettingId: 0,
        CompanyId: 0,
        DebtorNumber: '',
        Deduction: 0,
        IsDeleted: false,
        Misc: 0,
        Paint: 0,
        PaintMaterialsEnv: 0,
        ParentPartnerId: 0,
        PartnerId: 0,
        Salary: 0,
        SalaryEnv: 0,
        SpareParts: 0,
        SummationKickbacks: []
      },
      disabledDebtorNumber: false
    }

    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount (props) {
    this.getCollaboratingPartnerInvoiceSetting(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.item.Id !== nextProps.item.Id) {
      this.getCollaboratingPartnerInvoiceSetting(nextProps)
    }
  }

  getCollaboratingPartnerInvoiceSetting (props) {
    let isMainPartner = props.item.Partners !== undefined
    let parentPartnerShopId = isMainPartner ? props.item.ShopId : props.item.ParentPartnerShopId
    let partnerShopId = isMainPartner ? null : props.item.PartnerShopId

    let disabledDebtorNumber = props.item.ParentPartnerShopId !== undefined
    let partnerInvoiceSetting = this.state.PartnerInvoiceSetting
    if (typeof props.item === 'undefined') return
    props.getCollaboratingPartnerInvoiceSetting(parentPartnerShopId, partnerShopId).then((res) => {
      let data = res.data
      partnerInvoiceSetting = {
        ...data,
        Deduction: formatCurrency(data.Deduction),
        Misc: formatCurrency(data.Misc),
        Paint: formatCurrency(data.Paint),
        PaintMaterialsEnv: formatCurrency(data.PaintMaterialsEnv),
        Salary: formatCurrency(data.Salary),
        SalaryEnv: formatCurrency(data.SalaryEnv),
        SpareParts: formatCurrency(data.SpareParts),
        PartnerInvoiceSettingId: data.PartnerInvoiceSettingId,
        SummationKickbacks: data.SummationKickbacks
      }
      this.setState({
        PartnerInvoiceSetting: partnerInvoiceSetting,
        disabledDebtorNumber: disabledDebtorNumber
      })
    })
  }

  savePartnerSetting () {
    let data = this.state.PartnerInvoiceSetting
    data = {
      ...data,
      Salary: parseFloat(reverseFormatCurrency(formatCurrency2(data.Salary))),
      SpareParts: parseFloat(reverseFormatCurrency(formatCurrency2(data.SpareParts))),
      Misc: parseFloat(reverseFormatCurrency(formatCurrency2(data.Misc))),
      Paint: parseFloat(reverseFormatCurrency(formatCurrency2(data.Paint))),
      PaintMaterialsEnv: parseFloat(reverseFormatCurrency(formatCurrency2(data.PaintMaterialsEnv))),
      SalaryEnv: parseFloat(reverseFormatCurrency(formatCurrency2(data.SalaryEnv))),
      Deduction: parseFloat(reverseFormatCurrency(formatCurrency2(data.Deduction)))
    }
    this.props.createSavePartnerInvoiceSetting(data).then((res) => {
      let data = res.data
      let partnerInvoiceSetting = this.state.PartnerInvoiceSetting
      partnerInvoiceSetting = {
        ...partnerInvoiceSetting,
        Deduction: formatCurrency(data.Deduction),
        Misc: formatCurrency(data.Misc),
        Paint: formatCurrency(data.Paint),
        PaintMaterialsEnv: formatCurrency(data.PaintMaterialsEnv),
        Salary: formatCurrency(data.Salary),
        SalaryEnv: formatCurrency(data.SalaryEnv),
        SpareParts: formatCurrency(data.SpareParts),
        PartnerInvoiceSettingId: data.PartnerInvoiceSettingId,
        SummationKickbacks: data.SummationKickbacks
      }
      this.setState({
        PartnerInvoiceSetting: partnerInvoiceSetting
      })
      // Toastr
      // window.toastr.success(translation('15157'), translation('13424'))
    })
  }

  onBlur () {
    this.savePartnerSetting()
  }

  renderDebtorNumber () {
    let PartnerInvoiceSetting = this.state.PartnerInvoiceSetting
    const onChange = (e) => {
      PartnerInvoiceSetting[e.target.name] = e.target.value
      this.setState({
        PartnerInvoiceSetting: PartnerInvoiceSetting
      })
    }

    return (
      <Panel title={translation('17907')}>
        <Text
          labelText={PartnerInvoiceSetting.ParentPartnerName}
          name='DebtorNumber'
          value={PartnerInvoiceSetting.DebtorNumber || ''}
          onChange={onChange}
          onBlur={this.onBlur}
          disabled={this.state.disabledDebtorNumber}
        />
      </Panel>
    )
  }

  renderReturnCommissionWithReport (e) {
    let PartnerInvoiceSetting = this.state.PartnerInvoiceSetting

    const onChangeCommissionInput = (e) => {
      let value = e.target.value
      let currentIndex = PartnerInvoiceSetting.SummationKickbacks.findIndex(x => x.SummationGroupConfigId === parseInt(e.target.name))
      let updateItem = {
        ...PartnerInvoiceSetting.SummationKickbacks[currentIndex],
        Kickback: value
      }
      PartnerInvoiceSetting.SummationKickbacks[currentIndex] = updateItem
      this.setState({
        PartnerInvoiceSetting: PartnerInvoiceSetting
      })
    }

    const onAmountBlur = (e) => {
      let value = parseFloat(reverseFormatCurrency(formatCurrency2(e.target.value)))
      if (isNaN(value)) {
        // Toastr
        window.toastr.error(translation('15159'), translation('216'))
      } else if (value < 0 || value > 99.99) {
        // Toastr
        window.toastr.error(translation('15158'), translation('216'))
      } else {
        this.savePartnerSetting()
      }
    }

    const renderField = (item) => {
      return (
        <Grid align='center' spacing={1} key={item.SummationGroupConfigId}>
          <span>{item.Text}</span>
          <Text
            name={item.SummationGroupConfigId}
            value={PartnerInvoiceSetting.SummationKickbacks.find(x => x.SummationGroupConfigId === parseInt(item.SummationGroupConfigId)).Kickback}
            onChange={onChangeCommissionInput}
            onBlur={onAmountBlur}
            size='m'
          />
        </Grid>
      )
    }

    return (
      PartnerInvoiceSetting.SummationKickbacks ? PartnerInvoiceSetting.SummationKickbacks.map(renderField) : null
    )
  }

  renderReturnCommission (e) {
    let PartnerInvoiceSetting = this.state.PartnerInvoiceSetting

    const onChangeCommissionInput = (e) => {
      let value = e.target.value
      PartnerInvoiceSetting[e.target.name] = value
      this.setState({
        PartnerInvoiceSetting: PartnerInvoiceSetting
      })
    }

    const onAmountBlur = (e) => {
      let value = parseFloat(reverseFormatCurrency(formatCurrency2(e.target.value)))
      if (isNaN(value)) {
        // Toastr
        window.toastr.error(translation('15159'), translation('216'))
      } else if (value < 0 || value > 99.99) {
        // Toastr
        window.toastr.error(translation('15158'), translation('216'))
      } else {
        this.savePartnerSetting()
      }
    }

    const renderField = (name, label) => {
      return (
        <Grid align='center' spacing={1} key={name}>
          <span>{label}</span>
          <Text
            name={name}
            value={PartnerInvoiceSetting[name]}
            onChange={onChangeCommissionInput}
            onBlur={onAmountBlur}
            size='m'
          />
        </Grid>
      )
    }

    return [
      renderField('Salary', translation('416')),
      renderField('SpareParts', translation('637')),
      renderField('Misc', translation('15154')),
      renderField('Paint', translation('660')),
      renderField('PaintMaterialsEnv', translation('15155')),
      renderField('SalaryEnv', translation('15156')),
      renderField('Deduction', translation('15214'))
    ]
  }
  render () {
    /*  Old hardcoded kickback rates:
          <Col span='3'>
            <Panel title={translation('17914').replace('[CompanyName]', this.state.PartnerInvoiceSetting.ParentPartnerName)} helpText={translation('15036')}>
              <Grid align='center' spacing={1}>
                <span>{translation('70')}</span>
                <span>{translation('14904')}</span>
              </Grid>
              {this.renderReturnCommission()}
            </Panel>
          </Col>

    */
    return (
      <div>
        <Row>
          <Col>
            {this.renderDebtorNumber()}
          </Col>
        </Row>
        <Row>
          <Col span='3'>
            <Panel title={translation('18384').replace('[CompanyName]', this.state.PartnerInvoiceSetting.ParentPartnerName)} helpText={translation('15036')}>
              <Grid align='center' spacing={1}>
                <span>{translation('70')}</span>
                <span>{translation('14904')}</span>
              </Grid>
              {this.renderReturnCommissionWithReport()}
            </Panel>
          </Col>
        </Row>
      </div>
    )
  }
}

View.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}
export default connect(mapStateToProps, {
  getCollaboratingPartnerInvoiceSetting,
  createSavePartnerInvoiceSetting
}, null, {withRef: true})(View)



// WEBPACK FOOTER //
// ./src/app/pages/CollaboratingPartners/View/index.js